module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1277.0c270d8d.png";